import { z } from "zod";

export const signInSchema = z.object({
  email: z.email("Email non valida"),
  password: z.string().min(1, "Password richiesta"),
});
